import dayjs from 'dayjs'
import WeekDay from 'dayjs/plugin/weekday'

dayjs.extend(WeekDay)

const weekDayStrs = ['一', '二', '三', '四', '五', '六', '日']

export default {
  /**
   * @name 日期格式化
   * @param { String } value
   * @returns MM-DD 星期W
   */
  filterDateFormat1 (value) {
    if (!value) {
      return '--'
    }
    return `${dayjs(value).format('MM-DD')} 星期${weekDayStrs[dayjs(value).weekday() - 1]}`
  },
  /**
   * @name 日期格式化
   * @param { String } value
   * @returns MM-DD
   */
  filterDateFormat2 (value) {
    if (!value) {
      return '--'
    }
    return `${dayjs(value).format('MM-DD')}`
  },
  /**
   * @name 日期格式化
   * @param { String } value
   * @returns YYYY-MM-DD
   */
  filterDateFormat3 (value) {
    if (!value) {
      return '--'
    }
    return `${dayjs(value).format('YYYY-MM-DD')}`
  },
  /**
   * @name 日期格式化
   * @param { String } value
   * @returns YYYY-MM-DD hh:mm
   */
  filterDateFormat4 (value) {
    if (!value) {
      return '--'
    }
    return `${dayjs(value).format('YYYY-MM-DD hh:mm')}`
  },
  /**
   * @name 金额格式化 保留两位小数
   * @param { String | Number } value
   * @returns xx.yy
   */
  filterMoney1 (value) {
    value = Number(value)
    if (!value && value !== 0) {
      return '--'
    }
    return value.toFixed(2)
  },
  filterMoney2 (value) {
    value = Number(value)
    if (!value && value !== 0) {
      return '--'
    }
    value = parseFloat((value + '').replace(/[^\d.-]/g, '')).toFixed(2) + '' // n为小数点后保留小数位
    const l = value.split('.')[0].split('').reverse()
    const r = value.split('.')[1]
    let t = ''
    for (let i = 0; i < l.length; i++) {
      t += l[i] + ((i + 1) % 3 === 0 && (i + 1) !== l.length ? ',' : '')
    }
    return t.split('').reverse().join('') + '.' + r
  }
}
